import { useForm } from "react-hook-form";
import { StoreID, useRecoilState } from "recoil";
import { isOpenSettingModal } from "../atoms/isOpenSettingModal";
import { userStateAtom } from "../atoms/userStateAtom";
import axios from "axios";

interface FormValues {
  variant: string;
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
}

const SettingModal: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useRecoilState(isOpenSettingModal);
  const [userLoginState, setUserLoginState] = useRecoilState(userStateAtom);
  const userId: string = userLoginState.userData.userIdphp;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const spendMoney = async () => {
    try {
      const response = await axios.post(
        "https://chamstudyland.com/api/fun_learning/change_money.php",
        {
          id: userId,
          volume: -5,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("돈 응답", response.data);
    } catch (error) {
      console.log("Didn't decrease money error!", error);
    }
  };

  const postUserAvatar = async (data: FormValues) => {
    try {
      const response = await axios.post(
        "https://chamstudyland.com/api/fun_learning/change_avatar.php",
        {
          id: userId,
          variant: data.variant,
          color1: data.color1,
          color2: data.color2,
          color3: data.color3,
          color4: data.color4,
          color5: data.color5,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Avata change API response", response.data);
    } catch (error) {
      console.log("Avata data sending faild! ", error);
    }
  };

  const onSubmit = (data: FormValues) => {
    postUserAvatar(data);
    spendMoney();
    setIsModalOpen(false);
  };

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50 ">
      <div className="bg-white dark:bg-slate-600 p-6 rounded shadow-lg w-80 relative">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex justify-between align-top">
            <h2 className="text-xl mb-4 dark:text-slate-200">아바타 설정</h2>
            <button
              className="text-2xl dark:text-slate-200 hover:text-blue-500"
              onClick={() => setIsModalOpen(false)}
            >
              &rarr;
            </button>
          </div>
          <div className="flex justify-between">
            <div className="mb-4 dark:text-slate-200">
              <div className="mb-1 font-bold">아바타 종류</div>
              <label className="block mb-2">
                <input
                  className="mr-1"
                  type="radio"
                  value="marble"
                  {...register("variant", { required: true })}
                />
                marble
              </label>
              <label className="block mb-2">
                <input
                  className="mr-1"
                  type="radio"
                  value="beam"
                  {...register("variant", { required: true })}
                />
                beam
              </label>
              <label className="block mb-2">
                <input
                  className="mr-1"
                  type="radio"
                  value="pixel"
                  {...register("variant", { required: true })}
                />
                pixel
              </label>
              <label className="block mb-2">
                <input
                  className="mr-1"
                  type="radio"
                  value="sunset"
                  {...register("variant", { required: true })}
                />
                sunset
              </label>
              <label className="block mb-2">
                <input
                  className="mr-1"
                  type="radio"
                  value="ring"
                  {...register("variant", { required: true })}
                />
                ring
              </label>
              <label className="block mb-2">
                <input
                  className="mr-1"
                  type="radio"
                  value="bauhaus"
                  {...register("variant", { required: true })}
                />
                bauhaus
              </label>
              {errors.variant && (
                <p className="text-red-500">아바타 종류를 선택하세요</p>
              )}
            </div>

            <div className="mb-4 dark:text-slate-200">
              <div className="mb-1 font-bold">첫번째 색깔</div>
              <label className="block mb-2 text-pink-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#ec4899"
                  {...register("color1", { required: true })}
                />
                Pink
              </label>
              <label className="block mb-2 text-blue-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#3b82f6"
                  {...register("color1", { required: true })}
                />
                Blue
              </label>
              <label className="block mb-2 text-green-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#22c55e"
                  {...register("color1", { required: true })}
                />
                Green
              </label>
              {errors.color1 && (
                <p className="text-red-500">색상을 선택하세요</p>
              )}
            </div>
          </div>

          <div className="flex justify-between">
            <div className="mb-4 dark:text-slate-200">
              <div className="mb-1 font-bold">두번째 색깔</div>
              <label className="block mb-2 text-purple-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#a855f7"
                  {...register("color2", { required: true })}
                />
                Purple
              </label>
              <label className="block mb-2 text-yellow-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#eab308"
                  {...register("color2", { required: true })}
                />
                Yellow
              </label>
              <label className="block mb-2 text-teal-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#14b8a6"
                  {...register("color2", { required: true })}
                />
                Teal
              </label>
              {errors.color2 && (
                <p className="text-red-500">색상을 선택하세요</p>
              )}
            </div>
            <div className="mb-4 dark:text-slate-200">
              <div className="mb-1 font-bold">세번째 색깔</div>
              <label className="block mb-2 text-orange-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#f97316"
                  {...register("color3", { required: true })}
                />
                Orange
              </label>
              <label className="block mb-2 text-emerald-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#10b981"
                  {...register("color3", { required: true })}
                />
                Emerald
              </label>
              <label className="block mb-2 text-red-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#ef4444"
                  {...register("color3", { required: true })}
                />
                Red
              </label>
              {errors.color3 && (
                <p className="text-red-500">색상을 선택하세요</p>
              )}
            </div>
          </div>

          <div className="flex justify-between">
            <div className="mb-4 dark:text-slate-200">
              <div className="mb-1 font-bold">네번째 색깔</div>
              <label className="block mb-2 text-lime-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#84cc16"
                  {...register("color4", { required: true })}
                />
                Lime
              </label>
              <label className="block mb-2 text-indigo-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#6366f1"
                  {...register("color4", { required: true })}
                />
                Indigo
              </label>
              <label className="block mb-2 text-rose-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#f43f5e"
                  {...register("color4", { required: true })}
                />
                Rose
              </label>
              {errors.color4 && (
                <p className="text-red-500">색상을 선택하세요</p>
              )}
            </div>

            <div className="mb-4 dark:text-slate-200">
              <div className="mb-1 font-bold">다섯번째 색깔</div>
              <label className="block mb-2 text-violet-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#8b5cf6"
                  {...register("color5", { required: true })}
                />
                Violet
              </label>
              <label className="block mb-2 text-sky-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#0ea5e9"
                  {...register("color5", { required: true })}
                />
                Sky
              </label>
              <label className="block mb-2 text-fuchsia-500">
                <input
                  className="mr-1"
                  type="radio"
                  value="#d946ef"
                  {...register("color5", { required: true })}
                />
                Fuchsia
              </label>
              {errors.color5 && (
                <p className="text-red-500">색상을 선택하세요</p>
              )}
            </div>
          </div>
          <button type="submit" className="p-2 bg-pink-500 text-white rounded">
            선택
          </button>
        </form>
      </div>
    </div>
  );
};

export default SettingModal;
